import React, { type ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type RevealProps = {
  children: ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'li';
};
export function Reveal({
  children,
  delay = 0,
  className,
  as = 'div'
}: RevealProps) {
  const reduce = useReducedMotion();
  const Component = as === 'li' ? motion.li : motion.div;
  return <Component className={className} initial={reduce ? false : {
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1],
    delay
  }} data-id="element-191" data-mp="2jqpyrgs1wzcm">
      {children}
    </Component>;
}